import { useEffect } from "react";

const SITE = "https://djmagix.net";
const DEFAULT_ROBOTS = "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1";
const OG_LOCALES = { it: "it_IT", en: "en_US", de: "de_CH" };

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ title, description, path, jsonLd, noindex = false, lang = "it", alternates = [], image }) {
  const jsonLdString = jsonLd ? JSON.stringify(jsonLd) : null;
  const alternatesKey = JSON.stringify(alternates);

  useEffect(() => {
    document.title = title;
    document.documentElement.lang = lang;
    upsertMeta("name", "description", description);
    upsertMeta("name", "robots", noindex ? "noindex, nofollow" : DEFAULT_ROBOTS);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", `${SITE}${path}`);
    upsertMeta("property", "og:locale", OG_LOCALES[lang] || "it_IT");
    if (image) upsertMeta("property", "og:image", `${SITE}${image}`);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", `${SITE}${path}`);

    // hreflang alternates
    document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach((el) => el.remove());
    const altLinks = alternates.map((a) => {
      const el = document.createElement("link");
      el.setAttribute("rel", "alternate");
      el.setAttribute("hreflang", a.hreflang);
      el.setAttribute("href", `${SITE}${a.path}`);
      document.head.appendChild(el);
      return el;
    });

    let script;
    if (jsonLdString) {
      // evita duplicati con il JSON-LD statico della home (faq/landing)
      document.getElementById("ld-faq")?.remove();
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = jsonLdString;
      document.head.appendChild(script);
    }
    return () => {
      script?.remove();
      altLinks.forEach((el) => el.remove());
    };
  }, [title, description, path, jsonLdString, noindex, lang, alternatesKey, image]);
  return null;
}
